// import Loading from "components/common/Loading";
// import Product from "components/user/Product";
// import ProductPopUp from "components/user/ProductPopUp";
// import api from "config/api";
// import { useAppDispatch, useAppSelector } from "hooks/store";
// import React, { useEffect, useMemo, useState } from "react";
// import { useSearchParams } from "react-router-dom";
// import { setPizzaList, setSelected } from "store/slices/main.slice";

// type Props = {
//   isAdmin: boolean;
// };

// const Listing = (props: Props) => {
//   const dispatch = useAppDispatch();
//   const [searchParams] = useSearchParams();
//   const [products, setproducts] = useState<any[]>([]);
//   const [loading, setLoading] = useState(false);
//   const pizzaList = useAppSelector(({ main }) => main.pizzaList);

//   const fetchData = (id: string | null, setState: boolean = false) => {
//     if (id) {
//       setLoading(true);
//       setproducts([]);
//       api
//         .get("/api/Product/ByCategoryId?categoryId=" + id)
//         .then(({ data }) => {
//           if (!pizzaList.length && id !== "7") {
//             fetchData("7");
//           }

//           if (id === "7") {
//             dispatch(setPizzaList(data));
//           }
//           if (setState) {
//             setproducts(data);
//           }
//         })
//         .finally(() => setLoading(false));
//     }
//   };

//   const product = useMemo(
//     () => searchParams.get("product"),
//     [searchParams.get("product")]
//   );
//   useEffect(() => {
//     const timeout = setTimeout(() => {
//       fetchData(product, true);
//     }, 200);
//     return () => clearTimeout(timeout);
//   }, [product]);

//   return (
//     <div className="h-full relative z-0">
//       <div className="grid grid-cols-2 lg:grid-cols-3 gap-3 overflow-y-auto items-start max-h-full p-4 ">
//         {products.map((item) => (
//           <Product
//             {...item}
//             btnText="Add to cart"
//             onClick={() => dispatch(setSelected(item))}
//           />
//         ))}
//       </div>

//       {loading && <div className="h-44">
//         <Loading /> </div>}
//       <ProductPopUp />
//     </div>
//   );
// };

// export default Listing;

import Loading from "components/common/Loading";
import Product from "components/user/Product";
import ProductPopUp from "components/user/ProductPopUp";
import api from "config/api";
import { useAppDispatch, useAppSelector } from "hooks/store";
import { useEffect, useMemo, useRef, useState } from "react"; // === ADDED BY SAMPATH – 2026-01-12 ===
import { useSearchParams } from "react-router-dom";
import { setPizzaList, setSelected } from "store/slices/main.slice";
import EditProductDialog from "components/admin/EditProductDialog";

const Listing = () => {
  const dispatch = useAppDispatch();
  // === ADDED BY SAMPATH – 2026-01-12 ===
  // NEW: need setSearchParams to auto-select category in HorizontalBar while scrolling
  const [searchParams, setSearchParams] = useSearchParams();
  // === END SAMPATH ===
  // === ADDED BY SAMPATH – 2026-01-12 ===
  // OLD: const [searchParams] = useSearchParams();
  // === END SAMPATH ===

  const [products, setproducts] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const pizzaList = useAppSelector(({ main }) => main.pizzaList);
  const [selectProduct, setSelectProduct] = useState<any>(undefined);

  // === ADDED BY SAMPATH – 2026-01-12 ===
  // NEW: get categories (same source used by HorizontalBar.tsx)
  const sideBarMenu = useAppSelector(({ main }) => main.sideBarMenu);

  // NEW: store products grouped by categoryId
  const [productsByCat, setProductsByCat] = useState<Record<number, any[]>>({});

  // NEW: section refs by categoryId for smooth scrolling
  const catSectionRefs = useRef<Record<number, HTMLDivElement | null>>({});
  const catHeaderRefs = useRef<Record<number, HTMLDivElement | null>>({});

  // NEW: guard to prevent scroll-loop when URL param changes due to auto-scroll selection
  const shouldScrollOnParamRef = useRef(false);

  // NEW: keep last auto-selected category id to reduce spam updates
  const lastAutoSelectedRef = useRef<number>(0);
  const bannerFullyVisibleRef = useRef<boolean>(true);

  // NEW: helper for smooth scroll with offset (keeps header/menu visible)
  const scrollToCategory = (id: number) => {
    const el =
      catSectionRefs.current[id] || document.getElementById(`cat-${id}`);
    if (!el) return;

    requestAnimationFrame(() => {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
      // offset (HorizontalBar height + spacing)
      window.setTimeout(() => window.scrollBy({ top: -90, left: 0 }), 80);
    });
  };
  // === END SAMPATH ===

  // === ADDED BY SAMPATH – 2026-01-12 ===
  // CONTROL: grid mode -> "auto" (old setup) OR "max2" (desktop max 2, mobile 1)
  const DEFAULT_GRID_MODE: "auto" | "max2" = "max2";
  const gridMode =
    (searchParams.get("grid") as "auto" | "max2" | null) ?? DEFAULT_GRID_MODE;

  // === ADDED BY SAMPATH – 2026-01-29 ===
  // FIX: Reduce empty left/right margins on desktop by ~50% without changing grid structure.
  // - Before: max-w-6xl + px-4 (lots of side whitespace on large screens)
  // - After : max-w-7xl + px-2 md:px-3 lg:px-4 (tighter sides on desktop, still safe on mobile)
  const gridOuterClassName =
    gridMode === "max2" ? "w-full max-w-7xl mx-auto px-2 md:px-3 lg:px-4" : "w-full";
  // === END SAMPATH ===

  const gridClassName =
    gridMode === "max2"
      ? "grid grid-cols-1 md:grid-cols-2 gap-2 items-start"
      : "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 gap-3 items-start";
  // === END SAMPATH ===

  const fetchData = (id: string | null, setState: boolean = false) => {
    if (id) {
      setLoading(true);
      setproducts([]);
      const params = new URLSearchParams();
      params.set("categoryId", id);
      if (window.location.pathname.includes("admin")) {
        params.set("showAll", "true");
      }
      api
        .get("/api/Product/ByCategoryId?" + params.toString())
        .then(({ data }) => {
          if (!pizzaList.length && id !== "7") {
            fetchData("7");
          }

          if (id === "7") {
            dispatch(setPizzaList(data));
          }
          if (setState) {
            setproducts(data);
          }
        })
        .finally(() => setLoading(false));
    }
  };

  const product = useMemo(() => searchParams.get("product"), [searchParams]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      fetchData(product, true);
    }, 200);
    return () => clearTimeout(timeout);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [product]);

  // === ADDED BY SAMPATH – 2026-01-12 ===
  // NEW: Fetch ALL categories products and show under category headings
  useEffect(() => {
    if (!sideBarMenu?.length) return;

    let cancelled = false;

    const run = async () => {
      setLoading(true);
      try {
        const isAdmin = window.location.pathname.includes("admin");

        const results = await Promise.all(
          sideBarMenu.map(async ({ id }) => {
            const params = new URLSearchParams();
            params.set("categoryId", id.toString());
            if (isAdmin) params.set("showAll", "true");

            const { data } = await api.get(
              "/api/Product/ByCategoryId?" + params.toString()
            );
            return { id: Number(id), data: data || [] };
          })
        );

        if (cancelled) return;

        const map: Record<number, any[]> = {};
        results.forEach(({ id, data }) => {
          map[id] = data;
        });

        setProductsByCat(map);

        // keep your previous "products" state alive (popup/admin logic)
        const firstCat = sideBarMenu?.[0]?.id;
        if (firstCat && map[Number(firstCat)]?.length) {
          setproducts(map[Number(firstCat)]);
        }

        // preserve pizza special behavior
        const pizzaData = map[7];
        if (pizzaData?.length && !pizzaList.length) {
          dispatch(setPizzaList(pizzaData));
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    run();

    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sideBarMenu?.length]);
  // === END SAMPATH ===

  // === ADDED BY SAMPATH – 2026-01-12 ===
  // NEW: Listen for HorizontalBar click -> enable param-scroll guard and scroll to section
  useEffect(() => {
    const handler = (e: any) => {
      const id = Number(e?.detail?.id);
      if (!id) return;
      shouldScrollOnParamRef.current = true; // allow scroll when param changes from click
      scrollToCategory(id);
    };

    window.addEventListener("dcs:categoryScroll", handler as any);

    return () => {
      window.removeEventListener("dcs:categoryScroll", handler as any);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // === END SAMPATH ===

  // === ADDED BY SAMPATH – 2026-01-12 ===
  // UPDATED: only scroll on URL param change when it was triggered by click (prevents loop while auto-selecting on scroll)
  useEffect(() => {
    const id = Number(product || 0);
    if (!id) return;

    if (shouldScrollOnParamRef.current) {
      shouldScrollOnParamRef.current = false;
      scrollToCategory(id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [product]);
  // === END SAMPATH ===

  // === ADDED BY SAMPATH – 2026-01-12 ===
  // NEW: Auto-select HorizontalBar category while user scrolls (IntersectionObserver)
  useEffect(() => {
    if (!sideBarMenu?.length) return;

    const ids = sideBarMenu.map((x) => Number(x.id)).filter(Boolean);
    const updateActiveCategory = () => {
      const bestId = getBestActiveId();
      if (!bestId) return;

      if (lastAutoSelectedRef.current === bestId) return;
      lastAutoSelectedRef.current = bestId;

      const current = Number(searchParams.get("product") || 0);
      if (current === bestId) return;

      const sp = new URLSearchParams(searchParams);
      sp.set("product", String(bestId));
      setSearchParams(sp, { replace: true });
    };
    const getBestActiveId = () => {
      const productScrollEl =
        document.querySelector('[data-dcs-product-scroll="true"]') as HTMLElement | null;
      const productScrollTop = Math.max(0, productScrollEl?.scrollTop || 0);
      const categoryRow = document.querySelector('[data-dcs-category-row="true"]') as HTMLElement | null;
      const anchorY = categoryRow ? categoryRow.getBoundingClientRect().bottom + 8 : 150;
      const firstId = ids[0] || 0;
      const firstHeader =
        (firstId && catHeaderRefs.current[firstId]) || null;

      if (bannerFullyVisibleRef.current || productScrollTop <= 24) {
        return firstId;
      }

      if (firstHeader) {
        const firstHeaderTop = firstHeader.getBoundingClientRect().top;
        const firstHeaderBottom = firstHeader.getBoundingClientRect().bottom;

        if (firstHeaderBottom > anchorY && firstHeaderTop <= anchorY + 140) {
          return firstId;
        }
      }

      let bestPastId = 0;
      let bestPastTop = -Infinity;
      let bestFutureId = 0;
      let bestFutureTop = Infinity;

      ids.forEach((id) => {
        const el = catSectionRefs.current[id] || document.getElementById(`cat-${id}`);
        if (!el) return;

        const top = el.getBoundingClientRect().top;

        if (top <= anchorY && top > bestPastTop) {
          bestPastTop = top;
          bestPastId = id;
        }

        if (top > anchorY && top < bestFutureTop) {
          bestFutureTop = top;
          bestFutureId = id;
        }
      });

      return bestPastId || bestFutureId || ids[0] || 0;
    };

    let raf = 0;
    const observer = new IntersectionObserver(
      () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(updateActiveCategory);
      },
      {
        // observe section visibility, but calculate the active item by top position
        root: null,
        rootMargin: "-120px 0px -55% 0px",
        threshold: [0, 0.01, 0.1, 0.25, 0.5],
      }
    );

    ids.forEach((id) => {
      const el =
        catSectionRefs.current[id] || document.getElementById(`cat-${id}`);
      if (el) observer.observe(el);
    });

    const onScrollOrResize = () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(updateActiveCategory);
    };

    const onHeaderProgress = (event: Event) => {
      const customEvent = event as CustomEvent<{ isBannerFullyVisible?: boolean }>;
      bannerFullyVisibleRef.current = !!customEvent.detail?.isBannerFullyVisible;
      onScrollOrResize();
    };

    window.addEventListener("scroll", onScrollOrResize, { passive: true });
    window.addEventListener("resize", onScrollOrResize);
    window.addEventListener("dcs:headerProgress", onHeaderProgress as EventListener);
    onScrollOrResize();

    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("scroll", onScrollOrResize as any);
      window.removeEventListener("resize", onScrollOrResize as any);
      window.removeEventListener("dcs:headerProgress", onHeaderProgress as EventListener);
      observer.disconnect();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sideBarMenu?.length, productsByCat]);
  // === END SAMPATH ===

  return (
    <div className="h-full relative z-0 flex flex-col">
      <div className={gridOuterClassName}>
        <div className="flex flex-col gap-8 py-2">
          {sideBarMenu.map(({ id, categoryDescription }) => {
            const cid = Number(id);
            const list = productsByCat[cid] || [];
            if (!list.length) return null;

            return (
              <div
                key={cid}
                id={`cat-${cid}`}
                // === ADDED BY SAMPATH – 2026-01-12 ===
                // NEW: used by IntersectionObserver to identify the category
                data-cat-id={cid}
                // === END SAMPATH ===
                ref={(el) => {
                  catSectionRefs.current[cid] = el;
                }}
                className="w-full"
              >
                <div
                  ref={(el) => {
                    catHeaderRefs.current[cid] = el;
                  }}
                  className="sticky top-0 z-10 bg-white/90 backdrop-blur-sm py-2"
                >
                  {/* === ADDED BY SAMPATH – 2026-01-12 === */}
                  {/* UPDATED: category title font bold */}
                  <h2 className="text-deptColor font-bold text-[18px] tracking-wide">
                    {categoryDescription}
                  </h2>
                  {/* === END SAMPATH === */}
                </div>

                <div className={gridClassName}>
                  {list.map((item) => (
                    <Product
                      key={
                        item?.id ??
                        `${cid}-${item?.productId ?? Math.random()}`
                      }
                      {...item}
                      btnText={
                        window.location.pathname.includes("admin")
                          ? "Edit"
                          : "Add to cart"
                      }
                      onClick={() => {
                        dispatch(setSelected(item));
                        setSelectProduct(item);
                      }}
                    />
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {loading && (
        <div className="h-44">
          <Loading />
        </div>
      )}

      {window.location.pathname.includes("admin") ? (
        <EditProductDialog
          selected={selectProduct}
          setSelected={setSelectProduct}
          onComplete={(avoidRemove) => {
            if (!avoidRemove) setSelectProduct(undefined);
            fetchData(product, true);
          }}
        />
      ) : (
        <ProductPopUp />
      )}
    </div>
  );
};

export default Listing;
